import { ArrowForward } from "@mui/icons-material";
import { Container, Typography, useMediaQuery, useTheme, Box, Stack } from "@mui/material";
import React from "react";
import founderImg from '../assets/founder.jpeg';
import BookConsultation from "./book-consultation";
import f1 from "../assets/f1.jpeg";
import f2 from "../assets/f2.jpeg";

function About() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Container id="about" sx={{ marginTop: 8 }}>
            <Typography
                variant="h4"
                sx={{
                    fontFamily: 'Fredoka One, sans-serif',
                    color: 'grey.800',
                    marginBottom: '20px',
                }}
            >
                About
            </Typography>

            <Typography
                sx={{
                    fontSize: isMobile ? '1rem' : '1.2rem',
                    color: 'text.secondary',
                    lineHeight: 1.6,
                    marginBottom: '30px',
                }}
            >
                At <b>NutriEdu</b>, we empower healthier living through expert nutrition guidance and personalized care.
                Our platform is dedicated to enhancing nutrition practices and communication at every level, offering tailored counseling to support optimal health and manage disease with ease.
                Whether for individuals or families,
                we prioritize your well-being and productivity, helping you thrive in every aspect of life.
            </Typography>

            <Typography
                variant="h6"
                sx={{
                    fontFamily: 'Fredoka One, sans-serif',
                    color: 'grey.800',
                    marginBottom: '20px',
                }}
            >
                Founder
            </Typography>

            <Stack
                direction={isMobile ? 'column' : 'row'}
                spacing={4}
                alignItems={isMobile ? 'center' : 'flex-start'}
            >
                {/* Founder Image */}
                <Box
                    component="img"
                    src={f1}
                    alt="Founder"
                    sx={{
                        width: {xs: '250px', sm: '300px'},
                        height: {xs: '250px', sm: '300px'},
                        borderRadius: '50%',
                        boxShadow: theme.shadows[3],
                        objectFit: 'cover'
                    }}
                />

                {/* Founder Content */}
                <Box sx={{ flex: 1 }}>
                    <Typography
                        sx={{
                            fontSize: isMobile ? '1rem' : '1.2rem',
                            color: 'text.secondary',
                            lineHeight: 1.6,
                            marginBottom: '15px',
                        }}
                    >
                        <b>Dr. Udodiri Agatha Agugo</b> is a distinguished Senior Lecturer at the 
                        Federal University of Medical and Health Sciences, with expertise in 
                        Human Nutrition and Dietetics. 
                        She combines teaching, research, and leadership to advance nutrition education, research, and community health.
                    </Typography>

                    <Typography
                        component="ul"
                        sx={{
                            marginTop: 2,
                            marginBottom: 2,
                            paddingLeft: 3,
                            color: 'text.secondary',
                            fontSize: isMobile ? '0.95rem' : '1rem',
                            lineHeight: 1.6,
                            listStyleType: 'disc',
                        }}
                    >
                        <li>Senior Lecturer at Federal University of Medical and Health Sciences, Kwale, Delta State, Nigeria.</li>
                        <li>Contributed to Nigeria's core curriculum for minimum academic standard (CCMAS) for Nutrition and Dietetics programme: Ambrose Alli University Component.</li>
                        <li>Published extensively on Nutrition, health and food science related areas.</li>
                        <li>Recipient of research grants, including TETFund.</li>
                        <li>Recognized by Elsevier for excellence in peer review (2024).</li>
                        <li>Mentors, undergraduates, postgraduates, young women in STEM, with a focus on nutrition sciences.</li>
                        <li>Member of professional bodies- ASN, NSN, OWSD, WIT, NAAIP, & OWNN.</li>
                    </Typography>

                    {/* Read More Link */}
                    {/* <Box
                        sx={{
                            marginTop: 2,
                            fontSize: isMobile ? '1rem' : '1.1rem',
                            color: 'primary.main',
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 0.5,
                            textDecoration: 'underline',
                        }}
                        onClick={() => window.open('/about-founder', '_blank')} // Adjust the URL for the full profile
                    >
                        Read More <ArrowForward fontSize="small" />
                    </Box> */}

                    
                </Box>
            </Stack>
            <BookConsultation/>
        </Container>
    );
}

export default About;
